import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import routes from "routes/views.routes";

import "./view-container.component.scss";

class ViewContainer extends React.Component {
  render() {
    return (
      <div className="view-container container-fluid">
        <Switch>
          {routes.map((route, key) => {
            if (route.exact) {
              return (
                <Route
                  exact
                  path={route.path}
                  component={route.component}
                  key={key}
                />
              );
            }
            if (route.redirect) {
              return <Redirect from={route.path} to={route.pathTo} key={key} />;
            }
            return (
              <Route path={route.path} component={route.component} key={key} />
            );
          })}
        </Switch>
      </div>
    );
  }
}
export default ViewContainer;
